var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "order-dashboard" },
          [
            _c(
              "el-row",
              {
                staticClass: "graph-container",
                attrs: { type: "flex", gutter: 12 },
              },
              [
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 10 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { type: "flex", gutter: 12 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 16, xs: 24 } },
                          [
                            _c(
                              "el-card",
                              {
                                staticClass: "min-vh-175px",
                                attrs: { shadow: "always" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "clearfix",
                                    attrs: { slot: "header" },
                                    slot: "header",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("dashboard.filter"))
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("el-date-picker", {
                                  staticClass: "w-100 mt-18",
                                  attrs: {
                                    type: "daterange",
                                    clearable: false,
                                    "picker-options": {
                                      shortcuts: _vm.DATE_RANGE_OPTIONS(
                                        _vm.$i18n
                                      ),
                                      firstDayOfWeek: 7,
                                    },
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  on: { change: _vm.updateDashboard },
                                  model: {
                                    value: _vm.dateRange,
                                    callback: function ($$v) {
                                      _vm.dateRange = $$v
                                    },
                                    expression: "dateRange",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8, xs: 24 } },
                          [
                            _c(
                              "el-card",
                              {
                                staticClass: "min-vh-150px number-count-card",
                                attrs: { shadow: "always" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "clearfix",
                                    attrs: { slot: "header" },
                                    slot: "header",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dashboard.unassignedJobOrderCount"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("number-count", {
                                  attrs: {
                                    number: _vm.helper.get(
                                      _vm.summaryData,
                                      "count",
                                      0
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8, xs: 24 } },
                          [
                            _c(
                              "el-card",
                              {
                                staticClass: "min-vh-150px number-count-card",
                                attrs: { shadow: "always" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "clearfix",
                                    attrs: { slot: "header" },
                                    slot: "header",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dashboard.unassignedJobOrderWeight"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("number-count", {
                                  attrs: {
                                    number: _vm.helper.get(
                                      _vm.summaryData,
                                      "weight",
                                      0
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8, xs: 24 } },
                          [
                            _c(
                              "el-card",
                              {
                                staticClass: "min-vh-150px number-count-card",
                                attrs: { shadow: "always" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "clearfix",
                                    staticStyle: { "min-height": "48px" },
                                    attrs: { slot: "header" },
                                    slot: "header",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dashboard.unassignedJobOrderVolume"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("number-count", {
                                  attrs: {
                                    number: _vm.helper.get(
                                      _vm.summaryData,
                                      "volume",
                                      0
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8, xs: 24 } },
                          [
                            _c(
                              "el-card",
                              {
                                staticClass: "min-vh-150px number-count-card",
                                attrs: { shadow: "always" },
                              },
                              [
                                _vm.hasAssemblyMinutes
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "clearfix",
                                          attrs: { slot: "header" },
                                          slot: "header",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "dashboard.unassignedJobOrderAssemblyMinutes"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("number-count", {
                                        attrs: {
                                          number: _vm.helper.get(
                                            _vm.summaryData,
                                            "assemblyMinutes",
                                            0
                                          ),
                                        },
                                      }),
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "clearfix",
                                          staticStyle: { "min-height": "48px" },
                                          attrs: { slot: "header" },
                                          slot: "header",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "dashboard.unassignedJobOrderQuantity"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("number-count", {
                                        attrs: {
                                          number: _vm.helper.get(
                                            _vm.summaryData,
                                            "quantity",
                                            0
                                          ),
                                        },
                                      }),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 14 } },
                  [
                    _c(
                      "el-card",
                      {
                        staticClass: "min-vh-150px",
                        attrs: { shadow: "always" },
                      },
                      [
                        _c("heat-map", {
                          ref: "heatMap",
                          attrs: {
                            id: "dashboard-map",
                            mapData: _vm.summaryData.latlngList,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { staticClass: "graph-container", attrs: { gutter: 12 } },
              [
                _vm.summaryData.projectCode
                  ? _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "max-h-400px",
                            attrs: { shadow: "always" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "clearfix",
                                attrs: { slot: "header" },
                                slot: "header",
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("dashboard.projectCode"))
                                  ),
                                ]),
                              ]
                            ),
                            _vm.summaryData.projectCode.length >= 1
                              ? _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      size: "medium",
                                      border: "",
                                      data: _vm.summaryData.projectCode,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: { width: "40", type: "index" },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t("general.name"),
                                        prop: "name",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t("general.totalOrders"),
                                        prop: "count",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t(
                                          "planning.columns.weight"
                                        ),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        scope.row.weight
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1270768176
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t(
                                          "planning.columns.volume"
                                        ),
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        scope.row.volume
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3606431000
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.summaryData.zone
                  ? _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "max-h-400px",
                            attrs: { shadow: "always" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "clearfix",
                                attrs: { slot: "header" },
                                slot: "header",
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("dashboard.zone"))),
                                ]),
                              ]
                            ),
                            _vm.summaryData.zone.length >= 1
                              ? _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      size: "medium",
                                      border: "",
                                      data: _vm.summaryData.zone,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: { width: "40", type: "index" },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t("general.name"),
                                        prop: "name",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t("general.totalOrders"),
                                        prop: "count",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t(
                                          "planning.columns.weight"
                                        ),
                                        prop: "weight",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        scope.row.weight
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1270768176
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t(
                                          "planning.columns.volume"
                                        ),
                                        prop: "volume",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        scope.row.volume
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3606431000
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.summaryData.pickDistrict
                  ? _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "max-h-400px",
                            attrs: { shadow: "always" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "clearfix",
                                attrs: { slot: "header" },
                                slot: "header",
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("dashboard.pickDistrict"))
                                  ),
                                ]),
                              ]
                            ),
                            _vm.summaryData.pickDistrict.length >= 1
                              ? _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      size: "medium",
                                      border: "",
                                      data: _vm.summaryData.pickDistrict,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: { width: "40", type: "index" },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t("general.name"),
                                        prop: "name",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t("general.totalOrders"),
                                        prop: "count",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t(
                                          "planning.columns.weight"
                                        ),
                                        prop: "weight",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        scope.row.weight
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1270768176
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t(
                                          "planning.columns.volume"
                                        ),
                                        prop: "volume",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        scope.row.volume
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3606431000
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.summaryData.dropDistrict
                  ? _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "max-h-400px",
                            attrs: { shadow: "always" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "clearfix",
                                attrs: { slot: "header" },
                                slot: "header",
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("dashboard.dropDistrict"))
                                  ),
                                ]),
                              ]
                            ),
                            _vm.summaryData.dropDistrict.length >= 1
                              ? _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      size: "medium",
                                      border: "",
                                      data: _vm.summaryData.dropDistrict,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: { width: "40", type: "index" },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t("general.name"),
                                        prop: "name",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t("general.totalOrders"),
                                        prop: "count",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t(
                                          "planning.columns.weight"
                                        ),
                                        prop: "weight",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        scope.row.weight
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1270768176
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "120",
                                        label: _vm.$t(
                                          "planning.columns.volume"
                                        ),
                                        prop: "volume",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.helper.printThousandDecimal(
                                                        scope.row.volume
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3606431000
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }